// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_AV7-B clearfix","list":"index_list_UNCXZ"};